import {Component} from 'vue-property-decorator'
import Vue from 'vue'
import {namespace} from 'vuex-class'
import {
  AM_GET_ATTRIBUTE_TYPES,
  AM_MODULE_NAMESPACE,
  AM_SET_ATTRIBUTE_BY_FIELD
} from '../../../../store/agency-management'
import {CrudStatus} from '../../../../common/enums'

const AMStore = namespace(AM_MODULE_NAMESPACE)

@Component
class AmAttributeModalVertical extends Vue {
  @AMStore.Mutation(AM_SET_ATTRIBUTE_BY_FIELD)
  storeSetAttributeByValue: (payload: any) => void

  @AMStore.Getter attributeToEdit: any
  @AMStore.Getter attribute: any
  @AMStore.Getter amCrudActionStatus: CrudStatus
  @AMStore.Getter attributeTypes: any[]

  @AMStore.Action(AM_GET_ATTRIBUTE_TYPES)
  storeGetAttributeTypes: () => Promise<any>

  dtRules: {
    name?: any,
    type?: any,
    alertPreDelay?:any
  }

  constructor () {
    super()
    this.dtRules = {}
  }

  mounted () {
    this.dtRules = {
      name: [v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.amCharPbName)})],
      type: [v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.amAttributeType)})],
      alertPreDelay:[v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.amAlertBefore)})]
    }
    if (!this.attributeTypes || this.attributeTypes.length === 0) {
      this.storeGetAttributeTypes()
        .then(response => {
        })
    }
  }

  get lblSetting () {
    return {
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/agency-management').default
    }
  }

  get isUpdate (): boolean {
    return this.amCrudActionStatus === CrudStatus.Update
  }

  get name (): string {
    return this.attributeToEdit.name
  }

  set name (value: string) {
    this.storeSetAttributeByValue({name: value})
  }

  get unit (): string {
    return this.attributeToEdit.unit
  }

  set unit (value: string) {
    this.storeSetAttributeByValue({unit: value})
  }

  get fkAttributeType (): number {
    return this.attributeToEdit.fk_attribute_type
  }

  set fkAttributeType (value: number) {
    this.storeSetAttributeByValue({fk_attribute_type: value})
  }

  get used_by_maintenance (): boolean {
    return this.attributeToEdit.used_by_maintenance || false
  }

  set used_by_maintenance (value: boolean) {
    this.storeSetAttributeByValue({used_by_maintenance: value})
  }

  get used_by_alert (): boolean {
    return this.attributeToEdit.used_by_alert || false
  }

  set used_by_alert (value: boolean) {
    this.storeSetAttributeByValue({used_by_alert: value})
  }

  get alert_pre_delay (): number|null {
    return this.attributeToEdit.alert_pre_delay || null
  }

  set alert_pre_delay (value: number) {
    this.storeSetAttributeByValue({alert_pre_delay: value})
  }
}

export default AmAttributeModalVertical



// WEBPACK FOOTER //
// ./src/containers/profile/components/am-attribute-modal-vertical/index.ts